import LazyLoad from 'vanilla-lazyload';
import '../polyfills/vanilla-lazyload.min.js';
import {
	header,
	keyboardDetection,
	toggler,
	focusLock,
	scroller,
	videoOverlay,
	blog,
	cookieConsent,
} from '../modules';
import hotelSearch from '../modules/hotelSearch';

const common = {
	// JavaScript to be fired on all pages
	init() {
		new LazyLoad();
		header();
		keyboardDetection();
		hotelSearch();
		toggler();

		focusLock({
			elements: [document.querySelector('header')],
			sizes: [0, 767],
			controlledBy: document.querySelector('[class*=header__toggle]'),
		});

		blog();
		scroller();
		videoOverlay();
		cookieConsent();

		if (window.location.hash) {
			const element = document.querySelector(window.location.hash);
			element.scrollIntoView();
		}

		const holidexBtn = document.querySelector('.holidex-btn');

		if (holidexBtn) {
			holidexBtn.addEventListener('click', (e) => {
				const loader = document.createElement('div');
				loader.className = 'loader';
				holidexBtn.parentNode.append(loader);
				fetch('/wp-json/ihg/v1/update-holidex', {
					headers: {
						'X-WP-Nonce': holidexBtn.nextElementSibling.value,
					},
				})
					.then((response) => response.json())
					.then(json => {
						const message = document.createElement('div');
						message.textContent = 'Success!';
						holidexBtn.parentNode.append(message);

						loader.remove();
					})
					.catch((error) => {
						const message = document.createElement('div');
						message.textContent = 'Fail! Check console.log';
						holidexBtn.parentNode.append(message);
						console.error('Error:', error);

						loader.remove();

					});
			});
		}

		const formLanguageField = document.querySelectorAll('.gfield.form-language input[type="radio"]');
		if (formLanguageField) {
			formLanguageField.forEach(function (language_choice) {
				if (language_choice.value == document.documentElement.lang){
					// this is the language the user is viewing the form in
					language_choice.checked = true;
				}
			});
		}

		const scrollToTopButton = document.getElementById('scroll-to-top');

		scrollToTopButton.addEventListener('click', () => {
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
		});

		/**
		 * Copy btn--copy links to clipboard on click
		 */
		const copyLinkBtns = document.querySelectorAll('.btn--copy');
		copyLinkBtns.forEach(copyLinkBtn => {
			copyLinkBtn.addEventListener('click', (event) => {
				event.preventDefault();
				//copy the event.target.href to clipboard
				navigator.clipboard.writeText(event.target.href).then(function() {
					// Update the element so its visible as a tooltip
					const tooltip = event.target.querySelector('.tooltip');
					tooltip.classList.add('tooltip--visible');
					// remove the tooltip after 2 seconds
					setTimeout(function(){
						tooltip.classList.remove('tooltip--visible');
					}
					, 2000);
				});
			});
		});

		// Get all elements with class of jump-to__link
		const jumpToLinks = document.querySelectorAll('.jump-to__link');

		// Add click event listener to each jump-to link
		jumpToLinks.forEach(link => {
			link.addEventListener('click', event => {
				// Prevent default anchor behavior
				event.preventDefault();

				// Get the target anchor element
				const target = document.querySelector(link.getAttribute('href'));

				// Scroll to the target anchor element with an offset of 100 pixels
				window.scrollTo({
					top: target.offsetTop - 100,
					behavior: 'smooth',
				});
			});
		});


		/**
		 * Show or hide elements based on the selected language.
		 * @param {HTMLElement} select - The select element.
		 * @param {string} selectedLanguage - The selected language.
		 */
		function showHideElements(select, selectedLanguage) {
			if (!selectedLanguage) {
				selectedLanguage = select.querySelector('.child').value;
			}
			const notAvailable = select.querySelector('.resource__not-available');
			let allHidden = true;
			const children = select.querySelectorAll('.resource__item');

			children.forEach(child => {
				const isHidden = child.dataset.lang !== selectedLanguage;
				child.style.display = isHidden ? 'none' : 'block';
				child.classList.toggle('hidden', isHidden);
				allHidden = allHidden && isHidden;
			});

			notAvailable.style.display = allHidden ? 'block' : 'none';
		}


		const multiLangResources = document.querySelectorAll('.multi-lang');
		if (multiLangResources) {
			// Call the showHideElements() function once for each select element when the page loads.
			multiLangResources.forEach(select => {
				showHideElements(select);
			});

			// Add an event listener to each select element that calls the showHideElements() function whenever the selected language is changed.
			multiLangResources.forEach(childLanguageSelect => {
					childLanguageSelect.addEventListener('change', () => {
						showHideElements(childLanguageSelect);
					}
				);
			});
		}

		// Add an event listener to the parent select element that calls the showHideElements() function whenever the selected language is changed.
		const parentLanguageSelect = document.querySelector('.parent');
		if (parentLanguageSelect !== null) {
			parentLanguageSelect.addEventListener('change', () => {
				const selectedLanguage = parentLanguageSelect.value;
				const children = document.querySelectorAll('.multi-lang');
				children.forEach(child => {
					child.querySelector('.child').value = selectedLanguage;
					showHideElements(child, selectedLanguage);
				});
			});
		}


		// End of init
	},


	// JavaScript to be fired on all pages, after page specific JS is fired
	finalize() {},
};

export default common;



// WEBPACK FOOTER //
// ./scripts/routes/common.js